module.exports = "<div class=\"modal-header\">\r\n    <h4 class=\"modal-title\">\r\n        {{ $ctrl.resolve.title }}\r\n    </h4>\r\n </div>\r\n <div class=\"modal-body\">\r\n    <div ng-bind-html=\"$ctrl.resolve.content\"></div>\r\n </div>\r\n <div class=\"modal-footer\">\r\n    <rw-button action=\"$ctrl.close()\"\r\n               variant=\"contained\">\r\n       <translate>\r\n          OK\r\n       </translate>\r\n    </rw-button>\r\n </div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/app/components/home/management/components/terms/components/terms-preview-dialog/terms-preview-dialog.html
// module id = 2163
// module chunks = 0